import { TeacherFrontPageTranslations } from './types';

export const enTranslations: TeacherFrontPageTranslations = {
    buttons: {
        createClass: "Create a New Class",
        reviewClasses: "Review Previous Classes"
    }
};